import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=db1781c0&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/consumables.css?vue&type=style&index=0&id=db1781c0&prod&scoped=true&lang=css&external"
import style1 from "./detail.vue?vue&type=style&index=1&id=db1781c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1781c0",
  null
  
)

export default component.exports